var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-sortable",
        {
          attrs: { tag: "w-list", "target-class": "handle", items: _vm.items },
          on: {
            drop: function ($event) {
              return _vm.onSorted()
            },
          },
        },
        _vm._l(_vm.items, function (item) {
          return _c(
            "w-list-item",
            { key: item.getId(), attrs: { "show-handle": "" } },
            [
              _c("w-list-item-text", [
                _vm._v(_vm._s(_vm.$ct(`common.vat-regimes.${item.getId()}`))),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }